import { render, staticRenderFns } from "./SegmentFilterSelection.vue?vue&type=template&id=63b1ddf3&"
import script from "./SegmentFilterSelection.vue?vue&type=script&lang=js&"
export * from "./SegmentFilterSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports